function getApiStatus(props) {
  if (props.data.loading) {
    return 'loading';
  } else if (props.errors || props.data.error) {
    return 'error';
  } else {
    return 'loaded';
  }
}

function getApiError(props) {
  if (props.errors || props.data.error) {
    return (
      (props.errors && props.errors.message) ||
      (props.data.error && props.data.error.message) ||
      'Sorry, something went wrong.'
    );
  }
}

export { getApiStatus, getApiError };
